import {
  numberObjectEntries, stringObjectEntries,
} from '~/_shared/utils/object/objectEnumerators';
import { notNull } from '~/_shared/utils/typeGuards';
import type { MapSettingsDataAction } from '~/store/mapSettings/data/mapSettingsData.action';
import { MAP_SETTINGS_FETCH_DATA_SUCCESS } from '~/store/mapSettings/data/mapSettingsData.actionTypes';
import { DataType } from '~/store/spreadsheetData/spreadsheetData.state';
import { type MapPresentationalAction } from './mapPresentational.action';
import {
  mapPresentationalMapAccessTokenReceived,
  mapPresentationalSetShowPresentationalMenu,
  mapPresentationalSetShowWrongPasswordError,
  mapPresentationalSetView,
} from './mapPresentational.actionCreators';
import {
  type MapPresentationalState, MapPresentationalView,
} from './mapPresentational.state';

const initialState: MapPresentationalState = {
  availableGroupingColumns: [],
  isPresentationalMenuShown: false,
  showWrongPasswordError: false,
  view: MapPresentationalView.Loading,
  mapAccessToken: null,
};

export const mapPresentationalReducer = (
  state: MapPresentationalState = initialState,
  action: MapPresentationalAction | MapSettingsDataAction,
): MapPresentationalState => {
  if (mapPresentationalSetView.match(action)) {
    return {
      ...state,
      view: action.payload.view,
    };
  }

  if (mapPresentationalSetShowWrongPasswordError.match(action)) {
    return {
      ...state,
      showWrongPasswordError: action.payload.showPasswordError,
    };
  }

  if (mapPresentationalSetShowPresentationalMenu.match(action)) {
    return {
      ...state,
      isPresentationalMenuShown: action.payload.isMenuOpen,
    };
  }

  if (mapPresentationalMapAccessTokenReceived.match(action)) {
    return {
      ...state,
      mapAccessToken: action.payload.mapAccessToken,
    };
  }

  switch (action.type) {
    case MAP_SETTINGS_FETCH_DATA_SUCCESS: {
      return {
        ...state,
        availableGroupingColumns: [
          ...action.payload.mapSettingsData.grouping.activeGroupColumns?.map(column => ({
            columnId: column.columnId,
            spreadsheetId: column.spreadsheetId,
          })) ?? [],
          ...numberObjectEntries(action.payload.mapSettingsData.filtering.settings ?? {}).flatMap(([spreadsheetId, columns]) =>
            stringObjectEntries(columns).map(([columnId, setting]) => {
              if ([DataType.GROUP, DataType.NUMBER].includes(setting.type)) { // only group and number columns are considered
                return {
                  columnId,
                  spreadsheetId,
                };
              }
              return null;
            }).filter(notNull)
          ),
        ],
      };
    }

    default:
      return state;
  }
};
